module.exports = __webpack_public_path__ + "img/profile-arrow-down.2a5fcbec.svg";